// extracted by mini-css-extract-plugin
export var section = "logo-module--section--Kh0h0";
export var logo = "logo-module--logo--1zllg";